import React from "react";
import { useNavigate, useParams } from "react-router";
import SiteHeader from "../landing/components/Header/SiteHeader";
import Footer from "../landing/components/Footer/Footer";
import useFocusPageStart from "../../hooks/useFocusPageStart";
import Breadcrumb from "../schemes/components/Breadcrumb/Breadcrumb";
import Sidebar from "../schemes/components/Sidebar/Sidebar";
import CareerContent from "./components/CareerContent/CareerContent";
import careerMenuItems, {
  getCareerSection,
  normalizeCareerSection,
} from "./data/careerMenuItems";

const PageTitle = ({ label }) => {
  const title = label;

  return (
    <h1 className="m-0 text-[20px] font-bold leading-[1.2] uppercase tracking-[1px] text-[#1b3a6b] md:text-[23px] first-letter:text-[#ff9933]">
      {title}
    </h1>
  );
};

const CareerPage = () => {
  const navigate = useNavigate();
  const { section } = useParams();
  const activeSection = normalizeCareerSection(section);
  const currentSection = getCareerSection(activeSection);

  useFocusPageStart(section || activeSection);

  const handleSelectSection = (sectionId) => {
    navigate(`/career/${sectionId}`);
  };

  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "Work With Us", path: "/career" },
    { label: currentSection.label, path: `/career/${activeSection}` },
  ];

  return (
    <div className="flex min-h-screen flex-col bg-[#f5f5f5]">
      <SiteHeader className="shadow-[0_2px_4px_rgba(0,0,0,0.1)]">
        <div className="z-[1000] px-4 pt-2 pb-3 md:px-20 md:pb-4">
          <Breadcrumb items={breadcrumbItems} />
        </div>
      </SiteHeader>

      <main
        id="main-content"
        data-readable-content
        tabIndex={-1}
        className="flex-1 outline-none"
      >
        <div className="px-4 pt-7 pb-3.5 md:px-20 md:pb-[18px]">
          <PageTitle label={currentSection.label} />
        </div>

        <div className="mx-auto flex min-h-[360px] w-full max-w-[1400px] flex-col gap-5 px-5 pb-16 pt-5 md:min-h-[420px] md:px-10 md:pb-24 md:pt-10 lg:flex-row lg:items-start lg:gap-[30px]">
          <Sidebar
            activeSection={activeSection}
            onSelectSection={handleSelectSection}
            menuItems={careerMenuItems}
          />
          <CareerContent
            activeSection={activeSection}
            currentSection={currentSection}
          />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CareerPage;
